import { useState, useEffect, useCallback } from 'react';

const VOICE_SETTINGS_KEY = 'clarityos_voice_settings';

const defaultSettings = {
  voiceEnabled: true, // Default ON
  lastUpdated: null
};

export const useVoiceSettings = () => {
  const [settings, setSettings] = useState(() => {
    // Load from localStorage on initial render
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(VOICE_SETTINGS_KEY);
      if (stored) {
        try {
          return JSON.parse(stored);
        } catch (e) {
          console.error('Failed to parse voice settings:', e);
        }
      }
    }
    return defaultSettings;
  });

  // Persist to localStorage whenever settings change
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(VOICE_SETTINGS_KEY, JSON.stringify(settings));
    }
  }, [settings]);

  const setVoiceEnabled = useCallback((enabled) => {
    setSettings(prev => ({
      ...prev,
      voiceEnabled: enabled,
      lastUpdated: new Date().toISOString()
    }));
  }, []);

  const toggleVoice = useCallback(() => {
    setSettings(prev => ({
      ...prev,
      voiceEnabled: !prev.voiceEnabled,
      lastUpdated: new Date().toISOString()
    }));
  }, []);

  return {
    voiceEnabled: settings.voiceEnabled,
    setVoiceEnabled,
    toggleVoice
  };
};

export default useVoiceSettings;
